export default "/images/vendor/flag-icon-css/flags/1x1/ly.svg?8d6871917dd571682b3c533625d8b288";